<template>
  <div class="line-detail-box">
    <div class="line-detail">
      <div class="line-time-box"></div>
      <div class="line-icon-box">
        <img class="line-icon" src="~images/carStart.png" />
        <div class="line"></div>
      </div>
      <div class="line-text-box">
        <span class="line-text-nav">
          <div class="line-text">
            <span>{{
              lineDetail.data &&
              lineDetail.data.navigatSourceLocation | qxRemoveErrorString
            }}</span>
            <span
              class="line-text-error error"
              v-if="
                lineDetail.data &&
                lineDetail.ver &&
                lineDetail.data.nand &&
                lineDetail.ver.nand &&
                lineDetail.data.eand &&
                lineDetail.ver.eand &&
                (lineDetail.data.nand !== lineDetail.ver.nand ||
                  lineDetail.data.eand !== lineDetail.ver.eand)
              "
              >修改为：
              {{ lineDetail.ver && lineDetail.ver.navigatSourceLocation }}</span
            >
          </div>
        </span>
      </div>
    </div>

    <div class="line-detail">
      <div class="line-time-box"></div>
      <div class="line-icon-box">
        <img class="line-icon-small" src="~images/next.png" />
        <div class="line"></div>
      </div>
      <div class="line-text-box"></div>
    </div>

    <template
      v-if="
        lineDetail.data &&
        lineDetail.data.subWayList &&
        lineDetail.data.subWayList.length
      "
    >
      <div v-for="(item, index) in lineDetail.data.subWayList" :key="index">
        <div class="line-detail">
          <div class="line-time-box">
            <div class="line-time-text">{{ item.arriveTime }}小时</div>
            <div
              class="line-time-text-error error"
              v-if="
                lineDetail.ver &&
                lineDetail.ver.subWayList &&
                lineDetail.ver.subWayList[index] &&
                lineDetail.ver.subWayList[index].arriveTime &&
                item.arriveTime !== lineDetail.ver.subWayList[index].arriveTime
              "
            >
              {{ lineDetail.ver.subWayList[index].arriveTime }}小时
            </div>
          </div>
          <div class="line-icon-box">
            <img class="line-icon" src="~images/carMiddle.png" />
            <div class="line"></div>
          </div>
          <div class="line-text-box">
            <span class="line-text-nav">
              <div class="line-text">
                <span>{{
                  item.navigatDesLocation &&
                  item.navigatDesLocation | qxRemoveErrorString
                }}</span>
                <span
                  class="line-text-error error"
                  v-if="
                    lineDetail.ver &&
                    lineDetail.ver.subWayList &&
                    lineDetail.ver.subWayList[index] &&
                    lineDetail.ver.subWayList[index].nand &&
                    lineDetail.ver.subWayList[index].eand &&
                    (item.nand !== lineDetail.ver.subWayList[index].nand ||
                      item.eand !== lineDetail.ver.subWayList[index].eand)
                  "
                  >修改为：
                  {{
                    lineDetail.ver.subWayList[index].navigatDesLocation
                  }}</span
                >
              </div>
            </span>
          </div>
        </div>

        <div class="line-detail">
          <div class="line-time-box"></div>
          <div class="line-icon-box">
            <img class="line-icon-small" src="~images/next.png" />
            <div class="line"></div>
          </div>
          <div class="line-text-box"></div>
        </div>
      </div>
    </template>

    <div class="line-detail">
      <div class="line-time-box">
        <div class="line-time-text">
          {{ (lineDetail.data && lineDetail.data.arriveTime) || '0' }}小时
        </div>
        <div
          class="line-time-text-error error"
          v-if="
            lineDetail.data &&
            lineDetail.ver &&
            lineDetail.data.arriveTime &&
            lineDetail.ver.arriveTime &&
            lineDetail.data.arriveTime !== lineDetail.ver.arriveTime
          "
        >
          {{ lineDetail.ver && lineDetail.ver.arriveTime }}小时
        </div>
      </div>
      <div class="line-icon-box">
        <img class="line-icon" src="~images/carEnd.png" />
      </div>
      <div class="line-text-box">
        <span class="line-text-nav">
          <div class="line-text">
            <span>{{
              lineDetail.data && lineDetail.data.navigatDesLocation
            }}</span>
            <span
              class="line-text-error error"
              v-if="
                lineDetail.data &&
                lineDetail.ver &&
                lineDetail.data.nandDes &&
                lineDetail.ver.nandDes &&
                lineDetail.data.eandDes &&
                lineDetail.ver.eandDes &&
                (lineDetail.data.nandDes !== lineDetail.ver.nandDes ||
                  lineDetail.data.eandDes !== lineDetail.ver.eandDes)
              "
              >修改为：
              {{ lineDetail.ver && lineDetail.ver.navigatDesLocation }}</span
            >
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lineDetail: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.line-detail-box {
  font-size: 14px;
  padding: 14px 16px 14px 0;
  .line-detail {
    display: flex;
    align-items: center;
    .line-time-box {
      width: 84px;
      height: 24px;
      color: #ffffff;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      .line-time-text {
        width: 72px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        background-color: #ff632e;
        position: relative;
        &:before {
          position: absolute;
          content: '';
          width: 0;
          height: 0;
          border: transparent 0.85em solid;
          border-left-color: #ff632e;
          top: 0;
          right: -24px;
        }
      }
      .line-time-text-error {
        line-height: normal;
        text-align: center;
        width: 72px;
      }
    }
    .line-icon-box {
      margin-left: 18px;
      margin-right: 24px;
      width: 32px;
      height: 32px;
      position: relative;
      z-index: 1;

      display: flex;
      align-items: center;
      justify-content: center;
      .line-icon {
        display: block;
        width: 100%;
      }
      .line-icon-small {
        display: block;
        width: 16px;
        height: 16px;
      }
    }
    .line-text-box {
      height: 32px;
      display: flex;
      align-items: center;
      .line-text-nav {
        margin-right: 16px;
        display: flex;
        flex-direction: column;
        line-height: 16px;
        .line-text {
          display: flex;
          align-items: center;
          &.error {
            .line-text-title {
              text-align: right;
            }
          }
          .line-text-title {
            min-width: 70px;
          }
          .line-text-error {
            margin-left: 16px;
          }
        }
      }
    }
    .line {
      position: absolute;
      z-index: -1;
      left: 50%;
      top: 0;
      margin-left: -2px;
      width: 4px;
      height: 100%;
      background-color: #e6f7ff;
    }
    .line-detail-middle {
      height: 32px;
    }
  }
}
</style>
